export default {
      id: "geozones-no-visits-report-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/icons.svg#geozones-no-visits-report",
      toString: function () {
        return this.url;
      }
    }